export const formatKillsAndDeaths = (kills: number, deaths: number): string => {
  return `${kills}/${deaths} (${(kills / deaths).toFixed(2)})`
}
